import { ICapabilitiesDetailData } from '@core/modules/capacities/domain/types';

export type TUpdateCapabilitiesBags = {
  readonly id: number;
  readonly date: string;
  readonly capabilityDetails: ICapabilitiesDetailData[];
};

export type TCapabilityUploadStatus =
  | 'Error'
  | 'Not Loaded'
  | 'Successful'
  | 'Processing'
  | 'Pending';

export type TCapabilityUpload = {
  readonly lastProcessDate: string;
  readonly status: TCapabilityUploadStatus;
  readonly updatedAt: string;
  readonly errors: Record<string, TErrorData>;
};

export type TErrorData = {
  readonly rows: number[];
  readonly message: string;
  readonly count: number;
};

export enum ProccessStatus {
  Error = 'Fallido',
  Successful = 'Completado',
}

export type TProccessStatusData = {
  readonly show: boolean;
  readonly data: {
    readonly lastProcessDate: string;
    readonly status: ProccessStatus;
  };
};
